import firebase from '../firebase/firebaseIndex';

// Preserve existing one-time purchase and active/trial subscription entitlements.
// Errors propagate so a failed connection is never presented as a missing plan.
export default async function checkLessonAccess(user) {
  if (!user) return false;
  const account = firebase.firestore().collection('users').doc(user.uid);
  const payments = await account.collection('payments').limit(1).get();
  if (!payments.empty) return true;
  const subscriptions = await account.collection('subscriptions')
    .where('status', 'in', ['active', 'trialing']).limit(1).get();
  return !subscriptions.empty;
}
